import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["byTeamRoundButton", "alphabeticalButton", "byTeamRoundPanel", "alphabeticalPanel"]
  static values = { alphabetical: Boolean }

  connect() {
    this.render()
  }

  showAlphabetical(event) {
    event.preventDefault()
    this.alphabeticalValue = true
  }

  showByTeamRound(event) {
    event.preventDefault()
    this.alphabeticalValue = false
  }

  alphabeticalValueChanged() {
    this.render()
  }

  render() {
    const alphabetical = this.alphabeticalValue

    this.byTeamRoundButtonTarget.hidden = !alphabetical
    this.alphabeticalButtonTarget.hidden = alphabetical
    this.byTeamRoundPanelTarget.hidden = alphabetical
    this.alphabeticalPanelTarget.hidden = !alphabetical
  }
}
